import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'


const dayStats = {
  firestorePath: '/day-stats',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'dayStats',
  statePropName: 'dayStats',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state, getters, mutations, actions
}

export default dayStats